import { Quote } from "lucide-react";

const SECTIONS = [
  ["voor", "Uitgangssituatie"], ["wensen", "Wensen van de bewoners"], ["uitdaging", "Aandachtspunten"], ["oplossing", "Gekozen oplossing"],
  ["werk", "Uitgevoerde werkzaamheden"], ["montage", "Bijzonderheden tijdens de montage"], ["afwerking_binnen", "Binnenafwerking"],
  ["afwerking_buiten", "Buitenafwerking"], ["resultaat", "Resultaat"],
];

export const hasStory = (p) => Boolean(p.review_text) || SECTIONS.some(([k]) => p[k]?.trim());

export const ProjectStory = ({ p }) => (
  <div className="space-y-9" data-testid="project-story">
    {SECTIONS.filter(([k]) => p[k]?.trim()).map(([k, title]) => (
      <section key={k} aria-labelledby={`story-${k}`}>
        <h2 id={`story-${k}`} className="text-[22px] font-bold leading-snug text-ink sm:text-[24px]">{title}</h2>
        {p[k].split(/\n\s*\n/).map((para) => <p key={para.slice(0, 40)} className="mt-3 max-w-[68ch] leading-relaxed text-slate-700">{para}</p>)}
      </section>
    ))}
  </div>
);

export const ProjectReview = ({ p }) => (p.review_text ? (
  <figure className="rounded-2xl border border-slate-200 p-6 sm:p-8" style={{ background: "#F6F1E8" }} data-testid="project-review">
    <Quote className="h-7 w-7 text-gold" aria-hidden="true" />
    <blockquote className="mt-3 text-[17px] leading-relaxed text-ink sm:text-[18px]">“{p.review_text}”</blockquote>
    {p.review_name && <figcaption className="mt-4 text-[14px] font-semibold text-slate-600">— {p.review_name}{p.plaats ? `, ${p.plaats}` : ""}</figcaption>}
  </figure>
) : null);
